import React, { useEffect, useState } from "react";

import Sidebar from "./Sidebar";

import Navbar from "./Navbar";
import Cookies from "js-cookie";
import Config from "./Config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useAuthHandling } from './useAuthhandling';
import Deletemodal from "./Deletemodal";
import Nodatafound from "./Nodatafound";

function Subscriberslist() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [subscriberdata, setSubscriber] = useState([]);
  const [pagenum,setPagenum]=useState(1);
  const [paginate,setPaginate]=useState("");

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/newsletter-subscribers?page=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setSubscriber(data.data[0].data);
      setPaginate(data.data[0].total_pages);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/delete-newsletter-subscribers/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      const deletedata = await response.json();

      toast.success("Sucessfully deleted", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handlePageClick(pagenum);
    }
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
     
    }
  };

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/newsletter-subscribers?page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if(res.status === 200){
    const data = await res.json();
    return data.data[0].data;
  }
  else if(res.status === 401){
    handleUnauthorized();
    fetchComments(currentPage);
  }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setSubscriber(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPagenum(data);
    const commentsFormServer = await fetchComments(currentPage);

    setSubscriber(commentsFormServer);
    }
    
  };

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Subscriber List</h4>
                      <div className="table-responsive pt-3">
                      {subscriberdata?.length>0?
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Sl No</th>
                              <th>E-mail</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {subscriberdata.map((element, i) => {
                              return (
                                <>
                                  <tr>
                                    <th scope="row">{i + 1}</th>

                                    <td>{element.email}</td>

                                    <td>
                                      <Link
                                       to="#"

                                        onClick={() => tog_animationFlip(element._id)}

                                      >
                                        <i className="fa-solid fa-trash action_icons" />
                                      </Link>

                                    

                                      <ToastContainer />
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                        :
                        <Nodatafound/>
                      }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Subscriber"}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default Subscriberslist;
